/* 
  巡检工单 
 */
<template>
  <div style="margin: 20px">
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home_page/home_Page' }"
        >首页</el-breadcrumb-item
      >
      <el-breadcrumb-item>巡查工单</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 状态 -->
    <div class="operation_list">
      <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
        <el-tab-pane label="待处理（当前工单）" name="first">
          <el-table
            size="small"
            :data="listData"
            highlight-current-row
            border
            style="width: 100%"
          >
            <el-table-column
              align="center"
              prop="id"
              label="ID"
              width="80"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="car_id"
              width="200"
              label="车辆编号"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="name"
              width="100"
              label="运维人员"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="phone"
              width="150"
              label="运维手机号"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="create_time"
              width="200"
              label="开始时间"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="update_time"
              width="200"
              label="处理时间"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="outcome"
              width="500"
              label="巡检结果"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="status"
              width="200"
              label="当前状态"
            >
              <template slot-scope="scope">
                <el-tag size="small" type="danger">{{
                  scope.row.status
                }}</el-tag>
              </template>
            </el-table-column>

            <el-table-column
              align="center"
              fixed="right"
              label="操作"
              min-width="100"
            >
              <template slot-scope="scope">
                <el-button
                  size="mini"
                  type="primary"
                  icon="el-icon-edit"
                  circle
                  @click="handleEdit(scope.row)"
                ></el-button>
                <el-button
                  size="mini"
                  type="success"
                  icon="el-icon-check"
                  circle
                  @click="handleStatus(scope.row)"
                ></el-button>
              </template>
            </el-table-column>
          </el-table>
          <!-- 分页组件 -->
          <Pagination
            v-bind:child-msg="pageparm"
            @callFather="callFather"
          ></Pagination>
        </el-tab-pane>

        <el-tab-pane label="已完成（历史工单）" name="second">
          <!-- 列表 -->
          <el-table
            size="small"
            :data="tableData"
            highlight-current-row
            border
            style="width: 100%"
          >
            <el-table-column
              align="center"
              prop="id"
              label="ID"
              width="80"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="car_id"
              width="200"
              label="车辆编号"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="name"
              width="100"
              label="运维人员"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="phone"
              width="150"
              label="运维手机号"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="create_time"
              width="200"
              label="开始时间"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="update_time"
              width="200"
              label="处理时间"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="outcome"
              width="500"
              label="巡检结果"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="status"
              fixed="right"
              width="200"
              label="当前状态"
            ></el-table-column>
          </el-table>
          <!-- 分页组件 -->
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="page_parm.currentPage"
            background
            :page-sizes="[5, 10, 15, 25, 50, 100]"
            :page-size="page_parm.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="page_parm.total"
          ></el-pagination>
        </el-tab-pane>
      </el-tabs>
    </div>
    <!-- 编辑巡检结果 -->
    <el-dialog
      title="编辑巡检结果"
      :visible.sync="editFrom"
      width="30%"
      :close-on-click-modal="false"
    >
      <el-form :model="editFromList">
        <el-form-item label="巡检结果" label-width="80px">
          <el-input type="textarea" v-model="editFromList.outcome"></el-input>
        </el-form-item>
      </el-form>
      <div>
        <el-button size="mini" type="primary" @click="submitEdit"
          >确 定</el-button
        >
        <el-button size="mini" @click="editFrom = false">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Pagination from "../../components/Pagination";

export default {
  data() {
    return {
      editFrom: false,
      input: "",
      activeName: "first",

      listData: [],
      tableData: [],
      formInline: {
        status: "待处理",
        page: 1,
        limit: 10,
      },
      successFormInline: {
        status: "已完成",
        page: 1,
        limit: 10,
      },
      editFromList: {
        id: "",
        outcome: "",
      },
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10,
      },
      page_parm: {
        currentPage: 1,
        pageSize: 10,
        total: 10,
      },
    };
  },
  components: {
    Pagination,
  },
  created() {
    this.getdata();
    this.getOpData();
  },
  methods: {
    //待处理列表
    getdata(parm) {
      this.loading = true;
      let res = {
        data: [
          {
            car_id: "01",
            name: "小赞",
            phone: "15153448633",
            create_time: "2022-01-01",
            update_time: "2022-01-01",
            outcome: "无",
            status: "待处理",
          },
        ],
      };
      this.loading = false;
      this.listData = res.data;
    },
    
    //已处理列表
    getOpData(parm) {
      this.loading = true;
      let res = {
        data: [
          {
            car_id: "01",
            name: "小赞",
            phone: "15153448633",
            create_time: "2022-01-01",
            update_time: "2022-01-01",
            outcome: "无",
            status: "已完成",
          },
        ],
      };
      this.loading = false;
      this.tableData = res.data;
    },
    
    handleClick() {
      this.formInline.page = 1;
      this.successFormInline.page = 1;
      this.getdata();
      this.getOpData();
    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.currentPage;
      this.formInline.limit = parm.pageSize;
      this.getdata();
    },
    opFather() {
      this.successFormInline.page = this.page_parm.currentPage;
      this.successFormInline.limit = this.page_parm.pageSize;
      this.getOpData();
    },
    //修改状态
    handleStatus(row) {
      console.log("修改状态");

     
    },
    //编辑页面
    handleEdit(row) {
      this.editFromList = {};
      this.editFrom = true;
     
    },
    //编辑提交方法
    submitEdit() {
      this.editFrom = false;
     
    },
    handleSizeChange(val) {
      this.page_parm.pageSize = val;
      this.opFather();
    },
    handleCurrentChange(val) {
      this.page_parm.currentPage = val;
      this.opFather();
    },
  },
};
</script>

<style>
.operation_list {
  margin-top: 30px;
  width: 100%;
  height: 80px;
}
</style>


// WEBPACK FOOTER //
// src/views/operation_mn/Operation_mn.vue